import Vue from 'vue'
import { TIME_UNITS, MAX_END_SESSION_TIME_WITH_PROLONGATION } from '@/constants/business'

const validate = (value, { timeWithProlongation = MAX_END_SESSION_TIME_WITH_PROLONGATION, prolongation = 0, timeFormat = 'HH:mm:ss' } = {}) => {
  if (Vue.isTestMode()) {
    return true
  }
  if (!value) return false
  const endDate = Vue.prototype.$moment(value)
  // с учетом продления сессии
  const endDateWithProlongation = prolongation
    ? endDate.add(Number(prolongation), TIME_UNITS.MINUTES)
    : endDate

  const topTimeBoundaries = Vue.prototype.$moment(timeWithProlongation, timeFormat)

  return topTimeBoundaries.isSameOrAfter(Vue.prototype.$moment(endDateWithProlongation.format(timeFormat), timeFormat))
}

export default {
  validate,
  params: ['prolongation']
}
